<template>
  <div>
    <slot
      :saveExercise="saveExercise"
      :refItems="refItems"
      :exercise="exercise"
      :doc="doc"
    ></slot>
  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
// import lodash from "lodash";

export default {
  name: "ExerciseLogic",
  data() {
    return {
      componentReady: false,
      intervalId: null,
      exercise: null,
      ex: null,
      refItems: null,
      dialog: false,
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.init();
    next();
  },
  mounted() {
    this.init();
  },
  props: {
    exCollection: String,
    refCollection: String,
    doc: Object,
    shared: {
      type: Boolean,
      default: false,
    },
    projectShared: {
      type: Boolean,
      default: false,
    },
    pid: {
      type: Boolean,
      default: false,
    },
    eid: {
      type: String,
      default: null,
    },
    iterative: {
      type: Boolean,
      default: false,
    },
    synced: {
      type: Boolean,
      default: true,
    },
    saveState: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  watch: {
    saveState(val) {
      if (val) {
        this.saveExercise(false);
      }
    },
  },
  methods: {
    init() {
      let vm = this;
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.intervalId = setInterval(function() {
        vm.checkStatus();
      }, 300);
    },
    checkStatus() {
      if (this.currentProjectModel && this.currentProjectModel.id) {
        this.componentReady = true;
        this.$emit("ready");
        clearInterval(this.intervalId);
        if (this.$route.params.eid) {
          console.log("eid", this.$route.params.eid);
          this.getExercise();
        } else {
          console.log("no id");
          this.getExercise();
        }
        if (this.refCollection) {
          this.prePopulateOnce();
        }
      }
    },
    prePopulateOnce() {
      console.log("get reference material once", this.currentProjectModel.id);
      let ref = fb[this.refCollection].where(
        "pid",
        "==",
        this.currentProjectModel.id
      );
      ref
        .get()
        .then((result) => {
          let items = [];
          result.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.$emit("loadedRef", items);
          }
        })
        .catch(function() {});
    },
    getExercise() {
      console.log("get exercise");
      let ref;
      // const uid = this.currentUser.uid;
      if (this.eid) {
        ref = fb[this.exCollection]
          // .where("uid", "==", uid)
          .where("pid", "==", this.currentProjectModel.id)
          .where("id", "==", this.eid);
        // ref
        //   .get()
        //   .then((result) => {
        //     let items = [];
        //     result.forEach((docs) => {
        //       let doc = docs.data();
        //       items.push(doc);
        //     });
        //     if (items.length) {
        //       console.log("items", items[0]);
        //       this.exercise = items[0];
        //       this.$emit("loadedEx", items);
        //     }
        //   })
        //   .catch(function() {});
        ref.onSnapshot((querySnapshot) => {
          let items = [];
          querySnapshot.forEach((docs) => {
            let doc = docs.data();
            items.push(doc);
          });
          if (items.length) {
            console.log("items", items[0]);
            this.exercise = items[0];
            this.$emit("loadedEx", items);
          }
        });
      }
    },
    saveExercise(notify) {
      // check if exercise exists
      let ref;
      let uid = this.shared ? "shared" : this.currentUser.uid;
      // alert(this.exercise.id);
      // let vm = this;
      if (this.exercise == null) {
        console.log("no exercise");
        ref = fb[this.exCollection].doc();
      } else {
        console.log("has exercise", this.exercise.id);
        ref = fb[this.exCollection].doc(this.exercise.id);
      }
      console.log("start doc");
      console.log(this.doc);
      console.log("end doc");
      ref
        .set({
          updatedOn: new Date(),
          id: ref.id,
          uid: uid,
          pid: this.currentProjectModel.id,
          doc: this.doc,
        })
        .then(() => {
          this.exercise = ref;
          if (notify) {
            this.$emit("saved", { id: ref.id });
          } else {
            this.$emit("savedNext", { id: ref.id });
          }
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
  },
};
</script>
